// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1pXpy","buttons":"Footer_buttons__3fYqw"};